angular.module('mtic.components.dashboards.teacher_general')
.directive('teacherModules', function (
  $http,
  $log,
  $timeout,
  TIMING_CONSTANTS,
  EventManager,
  TeacherDataService,
  MapStateService
) {
  return {
    templateUrl: 'template.html',
    scope: {
      selectedClass: '=',
      interceptClick: '=?'
    },
    link: function (scope, element) {

      var eventManager = new EventManager('teacherModules', scope);
      var screen_width = 0;
      var is_mobile = navigator.userAgent.match(/Android/i) || (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream);
      if (is_mobile) {
        screen_width = window.screen.width
      } else {
        screen_width = window.innerWidth;
      }
      if(screen_width < 1200){
        var timer = is_mobile ? 500 : 0;
        $timeout(function(){
          eventManager.broadcast('teacher:toggle:Sidepanel', false);
        }, timer)
      }
      //scope.interceptClick = scope.interceptClick || null;

      TeacherDataService.isTeacherModuleView = true;
      scope.$on('$destroy', function() {
        TeacherDataService.isTeacherModuleView = false;
        MapStateService.setActiveModule("");
      });

      var init = function(firstInit) {
        scope.moduleData = null;
        eventManager.broadcast("teacherStudentWorkspace:studentFilter:change",{list:[]});
        TeacherDataService.getStudentWorkForModuleOfTeacher(scope.selectedClass.id, true).then(function(moduleData){
          if(firstInit) {
            $log.debug('[[teacherModules]] RE-INITED', moduleData)
            scope.moduleData = moduleData;
          }
          else{
            $log.debug('[[teacherModules]] RE-INITED', moduleData)
            $timeout(function(){
              scope.moduleData = moduleData;
            }, TIMING_CONSTANTS.INSTANT)
          }
        })
      }

      eventManager.listen('teacher:cycle:open', function (e) {
        init(true)
      });
      eventManager.listen('app:module:open', function (e) {
        init()
      });
      init(true)

      scope.$watch('selectedClass', function(selectedClass){
        if(selectedClass){
          $log.log('selectedClass: ' , selectedClass)
          eventManager.broadcast('teacher:cycle:open', {cycle: TeacherDataService.currentActiveMeta ? TeacherDataService.currentActiveMeta.slug : ''})
        }
      })

    }
  }
});
